/**
 * One helper: parse a feature's markup -- HTML comments included, they are
 * the design record and shipped inside the page before the split too -- and
 * put it in the document.  Returns the first element so the caller can hold
 * a handle to what it just made.  <template> rather than innerHTML on a div
 * because the content is inert while it parses (nothing fetches, nothing
 * runs) and comment nodes survive the trip.
 */
export function mount(html, parent = document.body) {
  const t = document.createElement("template");
  t.innerHTML = html;
  const el = t.content.firstElementChild;
  parent.appendChild(t.content);
  return el;
}
